const mode = {
    FRONT: "FRONT",
    WF: "WF"
};

export default {
    mode
};